import { render } from "./FooterCom.vue?vue&type=template&id=438dd176"
const script = {}

import "./FooterCom.vue?vue&type=style&index=0&id=438dd176&lang=scss"

import exportComponent from "I:\\cto\\mysoft\\gitee\\zhaoxi-flower-ui\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__